import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import CollapseContainer from '../FeedBackSynthesis/CollapseContainer';
import ChartDispersionData from '../charts/ChartDispersionData';

const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: 1280,
    margin: '0 auto'
  },
  title: {
    margin: '20px 0',
    fontSize: 22,
    textAlign: 'left'
  }
}));

const OperatingMetrics = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <CollapseContainer>
        <h3 className={classes.title}>Operating metrics</h3>
        <ChartDispersionData
          array={[2020, 2021, 2022, 2023, 2024]}
          date={2021}
        />
      </CollapseContainer>
    </div>
  );
};

export default OperatingMetrics;
